import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import moment from "moment";
import { FETCH_PROJECT } from "pages/development/projects/graphql";
import ProjectTasksView from "pages/development/projectTasks/ProjectTasksView";
import { Link } from "react-router-dom";

const StartUpProjectView = ({ startUpProjectId }) => {
  const { loading, error, data } = useQuery(FETCH_PROJECT, {
    variables: { id: startUpProjectId },
  });

  if (loading)
    return (
      <div className=" relative p-10">
        <InlineSpinner />
      </div>
    );

  if (error) return <Errors error={error} />;

  const projectData = JSON.parse(data.project.data);

  return (
    <div className="card">
      <div className="space-y-2">
        <h4>Team Red Project: {data.project.name}</h4>
        <Link to={`/development/projects/${startUpProjectId}`} target="_blank">
          Go to Team Red Project
        </Link>
      </div>

      <div className="space-y-4 mt-4">
        <div>
          <label>Goal &amp; Description</label>
          <p className="whitespace-pre-wrap">{data.project.goal}</p>
        </div>

        <div>
          <label>Timeline</label>
          <div className="flex space-x-6">
            <div>
              <label className="pr-3">Start: </label>
              <span>{moment(data.project.startDate).format("YYYY-MM-DD")}</span>
            </div>
            <div>
              <label className="pr-3">Target Release: </label>
              <span>
                {moment(data.project.releaseDate).format("YYYY-MM-DD")}
              </span>
            </div>
          </div>
        </div>

        <div>
          <label>Target Retail Price: </label>
          <span className="pl-3">${projectData.targetPrice}</span>
        </div>

        <ProjectTasksView projectId={startUpProjectId} projectType="RED" />
      </div>
    </div>
  );
};

export default StartUpProjectView;
